import { render, staticRenderFns } from "./SnapchatSubscription.vue?vue&type=template&id=5a20f4a5"
import script from "./SnapchatSubscription.vue?vue&type=script&lang=js"
export * from "./SnapchatSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports